<template>
  <div class="hidden md:flex bg-white border border-border rounded-lg p-3 mb-6 flex flex-col sm:flex-row justify-between items-center gap-4 shadow-sm">
    <div class="text-sm text-text-secondary font-medium ml-[10px]">
      {{ transPeralbaPro.item909 }}
      <span class="text-text-main font-bold">{{ count }}</span> 
      {{ transPeralbaPro.item910 }}
    </div>

    <div class="flex items-center gap-4">
      <div class="flex items-center gap-2"
        v-if="mobile">
        <span
          class="input-group-text"
          data-bs-toggle="modal"
          data-bs-target="#orderModal"
          v-if="mobile">
          <img
            src="/front/hi/sortby.svg"
            class="svg-inline--fa fa-sort-amount-down fa-w-16 uppercase"
          />
        </span>
      </div>
      <div class="flex items-center gap-2"
        v-else>
        <span
          id="span-ordenar" 
          class="text-xs text-text-secondary uppercase font-semibold hidden sm:inline">
          {{ transPeralbaPro.item911 }}:
        </span>
        <select
          id="select-order-products"
          @change="handleOrderChange"
          data-action="filter"
          data-item="sort"
          v-model="selectedOrder"
          class="cursor-pointer text-sm border-border rounded bg-surface focus:ring-primary focus:border-primary py-1.5 pl-3 pr-8">
          <option data-by="relevancia" value="relevance">
            {{ transPeralbaPro.item912 }}
          </option>
          <option data-by="precio" value="desc">
            {{ item13 }}
          </option>
          <option data-by="precio" value="asc">
            {{ item14 }}
          </option>
          <option data-by="best_sellers" value="sales">
            {{ transPeralbaPro.item881 }}
          </option>
          <option data-by="stock" value="stock_web">
            {{ transPeralbaPro.item315 }}
          </option>
        </select>
      </div>
      <div class="input-group-prepend input-group-select-order-products"
        v-if="mobile">
        <span
          class="input-group-text"
          data-bs-toggle="modal"
          data-bs-target="#quantityModal">
          <img
            src="/front/hi/quantity.svg"
            class="svg-inline--fa fa-sort-amount-down fa-w-16 me-2 uppercase"
          />
          {{ productsCountToShow }}
        </span>
      </div>
      <div class="flex items-center gap-2"
        v-else>
        <span class="text-xs text-text-secondary uppercase font-semibold hidden sm:inline"
          id="span-quantity">
          {{ transPeralbaPro.item1205 }}:
        </span>
        <select class="cursor-pointer text-sm border-border rounded bg-surface focus:ring-primary focus:border-primary py-1.5 pl-3 pr-8"
          id="select-quantity-products"
          @change="handleQuantityChange"
          data-action="filter"
          data-item="sort"
          v-model="quantity">
          <option data-by="25" value="25">25</option>
          <option data-by="50" value="50">50</option>
          <option data-by="100" value="100">100</option>
        </select>
      </div>
      <div
        class="flex border border-border rounded overflow-hidden h-[32px]">
        <!-- TODO
        <button class="p-1.5 "
          @click="changeTemplate(0)"
          :class="template == '0' ? 'bg-primary text-white' : 'bg-white text-text-secondary hover:bg-surface hover:text-text-main'"
          >
            <x-icons name="" class="" /> //view_list 
        </button>
        -->
        <button
            class="p-1.5 "
            @click="changeTemplate(1)"
            :class="template == '1' ? 'bg-primary text-white' : 'bg-white text-text-secondary hover:bg-surface hover:text-text-main'"
            >
            <x-icons name="grid_view" class="text-[20px]" />
        </button>
      </div>
    </div>

    <div class="col-12 p-0" v-if="mobile">
      <button
        type="button"
        class="btn-per-filtros mt-2"
        data-bs-toggle="modal"
        data-bs-target="#filtersModal"
      >
        <img src="/front/hi/filter.svg" /> {{ transPeralbaPro.item902 }}
      </button>
    </div>

    <!-- Modal -->
    <div
      class="modal right fade hidden"
      id="orderModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="
      orderModalLabel"
      >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="orderModalLabel">
              {{ transPeralbaPro.item911 }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mobile-order-products-list">
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('rel')"
              >
                <input
                  type="radio"
                  name="order"
                  value="rel"
                  @change="handleOrderChangeMobile('rel')"
                />
                <span>{{ transPeralbaPro.item912 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('desc')"
              >
                <input
                  type="radio"
                  name="order"
                  value="desc"
                  @change="handleOrderChangeMobile('desc')"
                />
                <span>{{ item13 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('asc')"
              >
                <input
                  type="radio"
                  name="order"
                  value="asc"
                  @change="handleOrderChangeMobile('asc')"
                />
                <span>{{ item14 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('sales')"
              >
                <input
                  type="radio"
                  name="order"
                  value="sales"
                  @change="handleOrderChangeMobile('sales')"
                />
                <span>{{ transPeralbaPro.item881 }}</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickOrderChangeMobile('stock_web')"
              >
                <input
                  type="radio"
                  name="order"
                  value="stock_web"
                  @change="handleOrderChangeMobile('stock_web')"
                />
                <span>{{ transPeralbaPro.item315 }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn-per-dark w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              {{ transPeralbaPro.item905 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal right fade hidden"
      id="quantityModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="
      quantityModalLabel"
      >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="quantityModalLabel">
              {{ transPeralbaPro.item1205 }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mobile-order-products-list">
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(25)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="25"
                  @change="handleQuantityChangeMobile(25)"
                />
                <span>25</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(50)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="50"
                  @change="handleQuantityChangeMobile(50)"
                />
                <span>50</span>
              </div>
              <div
                class="item-order-products-list"
                @click.prevent="clickQuantityChangeMobile(100)"
              >
                <input
                  type="radio"
                  name="quantity"
                  value="100"
                  @change="handleQuantityChangeMobile(100)"
                />
                <span>100</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn-per-dark w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              {{ transPeralbaPro.item905 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "page-control",
  // El bloque `filters: { uppercase }` que habia aqui estaba muerto: ninguna
  // expresion de esta plantilla usaba `| uppercase` (Vue 3 no tiene filtros).
  props: [
    "count",
    "query",
    "item10",
    "item11",
    "item12",
    "item13",
    "item14",
    "item15",
    "template",
    "mobile",
    "transPeralbaPro",
    "productsCountToShow",
    "order",
  ],
  emits: ["onChangeTemplate", "onOrderChange", "onQuantityChange"],
  data() {
    return {
      selectedOrder: null,
      quantity: 25,
    };
  },
  created() {
    this.selectedOrder = this.order || "relevance";
    this.quantity = this.productsCountToShow;
  },
  methods: {
    changeTemplate(template) {
      console.log(event);
      this.$emit("onChangeTemplate", template);
    },
    handleOrderChange(event) {
      this.$emit("onOrderChange", event.target.value);
    },
    handleQuantityChange(event) {
      console.warn(event);
      this.$emit("onQuantityChange", event.target.value);
    },
    clickOrderChangeMobile(orderBy) {
      console.log("click row");
      const input = this.$el.querySelector(`input[value="${orderBy}"]`);
      if (input) {
        input.checked = true;
        this.handleOrderChangeMobile(orderBy);
      }
    },
    clickQuantityChangeMobile(quantity) {
      console.log("click row quant " + quantity);
      const input = this.$el.querySelector(`input[value="${quantity}"]`);
      if (input) {
        input.checked = true;
        // Antes tambien escribia `this.productsCountToShow = quantity`, que es
        // una prop: en Vue 3 las props son de solo lectura y la asignacion
        // lanza TypeError. Era redundante — el emit de abajo la actualiza en el
        // padre y vuelve por la misma prop con el mismo valor.
        this.handleQuantityChangeMobile(quantity);
      }
    },
    handleOrderChangeMobile(orderBy) {
      console.log("emit");
      this.$emit("onOrderChange", orderBy);
    },
    handleQuantityChangeMobile(quantity) {
      console.log("emit");
      this.$emit("onQuantityChange", parseInt(quantity));
    },
  },
};
</script>
